import styles from './index.module.less'
import { VCard, VIcon } from 'vuetify/lib'
export default {
    props: {
        list: {
            type: Array,
            default: () => []
        }  
    },
    render() {
        const _this = this
        return <VCard>
                <div style="text-align:right;padding:5px;">
                    <VIcon
                        class={styles['cursor']}
                        right
                        on={{
                            click: () => {
                                _this.$emit('close')
                            }
                        }}
                        >mdi-close</VIcon>
                </div>
                <div class={styles['card-d']}>
                    {_this.list.map(item => {
                        if (item.only) {
                            return <p class={styles['p-c']}>{item.content}</p>
                        }
                        return <p class={styles['p-c']}><b>{item.title}</b>
                        {item.content}
                        <span style="font-weight:bold;color:red">{item.content_1}</span>
                        </p>
                    })}
               
                </div>
            </VCard>
       
    }
}